/* eslint-disable global-require */

import 'babel-polyfill';

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { applyRouterMiddleware, Router, browserHistory } from 'react-router';
import { useScroll } from 'react-router-scroll';
import { ReduxAsyncConnect } from 'redux-connect';
import { ApolloProvider } from 'react-apollo';

import configureStore from './state/store';
import gqlClient from './state/services/gql';

const rootElement = document.getElementById('app');

const renderApp = () => {
  // Configure store with global state injected by server-generated HTML
  const store = configureStore(window.__INITIAL_STATE__); // eslint-disable-line

  // Require routes within block scope (see hot reloading below)
  const routes = require('./routes');

  // Client application uses Router component, browser history and Redux async middleware
  const App = () => (
    <ApolloProvider client={gqlClient}>
      <Provider store={store}>
        <Router
          history={browserHistory}
          render={props =>
            <ReduxAsyncConnect
              {...props}
              render={
                applyRouterMiddleware(
                  useScroll((prevRouterProps, { location }) => (
                    prevRouterProps && location.pathname !== prevRouterProps.location.pathname
                  ),
                ))}
            />}
          routes={routes}
        />
      </Provider>
    </ApolloProvider>
  );
  render(<App />, rootElement);
};

// Support hot reloading of components
if (module.hot) {
  const RedBox = require('redbox-react');
  const hotRender = () => {
    try {
      renderApp();
    } catch (error) {
      // Show overlay for runtime errors
      render(<RedBox error={error} />, rootElement);
    }
  };
  // Use routes as dependency entry
  module.hot.accept('./routes', hotRender);
}

renderApp();



// WEBPACK FOOTER //
// ./app/src/client.js